import templateUrl from '../views/modals/add-wallet-template-modal.tpl.html';
import AddWalletTemplateModalController from '../controllers/modals/add-wallet-template-modal';

export default function addWalletTemplateModalCreator($injector) {
    return $injector.get('$uibModal')
        .open({
            controller: AddWalletTemplateModalController,
            controllerAs: 'vm',
            templateUrl,
            backdrop: 'static',
            size: 'lg',
            keyboard: false,
        })
        .result
}



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/helpers/add-wallet-template-modal-creator.js